(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["module", "exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(module, exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports);
    global.ptBR = mod.exports;
  }
})(this, function (module, exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    "rich": {
      "validator": {
        "type": {
          "array": "O tipo de dados deve ser uma matriz",
          "url": "Insira uma URL válida",
          "date": "Insira uma data válida",
          "email": "Insira um e-mail válido",
          "string": "Insira caracteres",
          "tel": "Insira um número de telefone válido",
          "number": "Insira números"
        },
        "max": {
          "tel": "Não pode exceder {{config}} caracteres",
          "number": "Não pode ter mais de {{config}}",
          "email": "Não pode exceder {{config}} caracteres",
          "url": "Não pode exceder {{config}} caracteres",
          "date": "Selecione uma data antes de {{config | toLocaleDateString(\"yyyy-MM-dd\")}}",
          "array": "Selecionar até {{config}} itens",
          "string": "Não pode exceder {{config}} caracteres"
        },
        "min": {
          "string": "Insira pelo menos {{config}} caracteres",
          "array": "Selecione um mínimo de {{config}} itens",
          "email": "Insira pelo menos {{config}} caracteres",
          "tel": "Insira pelo menos {{config}} caracteres",
          "number": "Não pode ter menos de {{config}}",
          "date": "Selecione uma data depois de {{config | toLocaleDateString(\"yyyy-MM-dd\")}}",
          "url": "Insira pelo menos {{config}} caracteres"
        },
        "len": {
          "string": "Insira {{config}} caracteres",
          "number": "O comprimento deve ser igual a {{config}}",
          "array": "Selecione {{config}} itens",
          "tel": "Insira {{config}} caracteres",
          "date": "Selecione uma data antes de {{config | toLocaleDateString(\"yyyy-MM-dd\")}}",
          "email": "Insira {{config}} caracteres",
          "url": "Insira {{config}} caracteres"
        },
        "notWhitespace": "Conteúdo em branco inválido",
        "custom": "Falha na verificação",
        "pattern": "Erro de formato",
        "required": "Obrigatório"
      },
      "timePicker": {
        "minutes": "",
        "hours": "",
        "today": "Hoje",
        "formatDate": "DD/MM",
        "selectTime": "Selecione o horário",
        "now": "Agora"
      },
      "textArea": {
        "placeholder": "Especifique..."
      },
      "resultPage": {
        "networkSubtext": "Toque para tentar novamente",
        "emptyText": "Não há dados disponíveis",
        "networkText": "Erro de rede",
        "lostText": "A página que você está procurando não foi encontrada"
      },
      "common": {
        "selectText": "Selecione",
        "ok": "OK",
        "cancel": "Cancelar",
        "confirm": "OK"
      },
      "segmentPicker": {
        "next": "Avançar",
        "prev": "Voltar"
      }
    }
  };
  module.exports = exports["default"];
});